import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { ExternalUrlItemValidation } from '../types-store';
import { ExternalUrlSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<ExternalUrlSectionType>[],
  validation: ExternalUrlItemValidation
): [Configuration<ExternalUrlSectionType>, React.Dispatch<React.SetStateAction<Configuration<ExternalUrlSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);

  useEffect(() => {
    if (invalidSection === undefined && validation !== previousValidation
    ) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation]);

  return [invalidSection, updateInvalidSection];
};
